import i200 from '../assets/images/activities/plus/200.png';
import i201 from '../assets/images/activities/plus/201.PNG';
import i202 from '../assets/images/activities/plus/202.PNG';
import i203 from '../assets/images/activities/plus/203.PNG';
import i204 from '../assets/images/activities/plus/204.png';
import i205 from '../assets/images/activities/plus/205.png';
import i206 from '../assets/images/activities/plus/206.png';
import i208 from '../assets/images/activities/plus/208.png';
import i209 from '../assets/images/activities/plus/209.png';
import i210 from '../assets/images/activities/plus/210.png';
import i211 from '../assets/images/activities/plus/211.png';
import i214 from '../assets/images/activities/plus/214.png';
import i215 from '../assets/images/activities/plus/215.png';
import i216 from '../assets/images/activities/plus/216.png';
import i217 from '../assets/images/activities/plus/217.png';
import i218 from '../assets/images/activities/plus/218.png';
import i219 from '../assets/images/activities/plus/219.png';
import i221 from '../assets/images/activities/plus/221.png';
import i222 from '../assets/images/activities/plus/222.png';
import i223 from '../assets/images/activities/plus/223.png';
import i224 from '../assets/images/activities/plus/224.png';
import i225 from '../assets/images/activities/plus/225.png';
import i226 from '../assets/images/activities/plus/226.png';
import i227 from '../assets/images/activities/plus/227.png';
import i230 from '../assets/images/activities/plus/230.png';
import i231 from '../assets/images/activities/plus/231.png';
import i233 from '../assets/images/activities/plus/233.png';
import i234 from '../assets/images/activities/plus/234.png';
import i301 from '../assets/images/activities/plus/301.png';
import i302 from '../assets/images/activities/plus/302.png';
import i303 from '../assets/images/activities/plus/303.png';
import i304 from '../assets/images/activities/plus/304.png';
import i307 from '../assets/images/activities/plus/307.png';

export const PLUS_PROTOCOLS = [
  { id: 200, name: 'Entrenamiento RA',       icon: i200 },
  { id: 201, name: 'Memosec',                icon: i201 },
  { id: 202, name: '¿Adivina qué?',          icon: i202 },
  { id: 203, name: 'Pianosec',               icon: i203 },
  { id: 204, name: 'Encájalo',               icon: i204 },
  { id: 205, name: 'Abecedario RA',          icon: i205 },
  { id: 206, name: 'Globos RA',              icon: i206 },
  { id: 208, name: 'Estantes RA',            icon: i208 },
  { id: 209, name: 'Patos RA',               icon: i209 },
  { id: 210, name: 'Buffet RA',              icon: i210 },
  { id: 211, name: 'Armanoid',               icon: i211 },
  { id: 214, name: 'Gotas',                  icon: i214 },
  { id: 215, name: 'De compras',             icon: i215 },
  { id: 216, name: 'A limpiar',              icon: i216 },
  { id: 217, name: 'A conducir',             icon: i217 },
  { id: 218, name: 'Esferoides RA',          icon: i218 },
  { id: 219, name: 'Hockey RA',              icon: i219 },
  { id: 221, name: 'Día de pesca RA',        icon: i221 },
  { id: 222, name: 'Popurrí',                icon: i222 },
  { id: 223, name: 'Twister',                icon: i223 },
  { id: 224, name: 'Memory',                 icon: i224 },
  { id: 225, name: 'Hora de fregar RA',      icon: i225 },
  { id: 226, name: 'Tubos RA',               icon: i226 },
  { id: 227, name: 'Limpieza de lienzo RA',  icon: i227 },
  { id: 230, name: 'Control de Calidad RA',  icon: i230 },
  { id: 231, name: 'Globos',                 icon: i231 },
  { id: 233, name: 'Constelaciones RA',      icon: i233 },
  { id: 234, name: 'Lluvia de objetos',      icon: i234 },
  { id: 301, name: 'Memosec Web',            icon: i301 },
  { id: 302, name: 'Memosec Espejo Web',     icon: i302 },
  { id: 303, name: 'Reciclaje',              icon: i303 },
  { id: 304, name: 'Whackamole Web',         icon: i304 },
  { id: 307, name: 'Secuencias',             icon: i307 },
];

export const WEEKDAYS = [
  { key: 'MONDAY',    label: 'Lunes' },
  { key: 'TUESDAY',   label: 'Martes' },
  { key: 'WEDNESDAY', label: 'Miércoles' },
  { key: 'THURSDAY',  label: 'Jueves' },
  { key: 'FRIDAY',    label: 'Viernes' },
  { key: 'SATURDAY',  label: 'Sábado' },
  { key: 'SUNDAY',    label: 'Domingo' },
];
